import React, { useEffect } from 'react';
import { Shield, ExternalLink } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import Title from '../ui/Title';
import Description from '../ui/Description';
import Button from '../ui/Button';

export default function UnsuccessfulApplication() {
  const { t } = useTranslation('terminal');

  useEffect(() => {
    // Set application block in localStorage with unsuccessful status
    localStorage.setItem('applicationSuccess', JSON.stringify({
      timestamp: Date.now(),
      email: sessionStorage.getItem('formData') ? JSON.parse(sessionStorage.getItem('formData')!).email : '',
      formData: sessionStorage.getItem('formData') ? JSON.parse(sessionStorage.getItem('formData')!) : {},
      status: 'unsuccessful'
    }));
    
    // Clear form data from sessionStorage
    sessionStorage.removeItem('formData');
  }, []);

  return (
    <div id="unsuccessful-application" className="text-center">
      <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
        <Shield className="w-8 h-8 text-red-600" />
      </div>

      <Title 
        id="unsuccessful-title"
        name="unsuccessful-title"
        as="h1" 
        className="mb-2"
      >
        {t('unsuccessful.title')}
      </Title>
      <Description 
        id="unsuccessful-description"
        name="unsuccessful-description"
        size="lg" 
        className="max-w-md mx-auto mb-6"
      >
        {t('unsuccessful.description')}
      </Description>
      
      <div className="w-1/2 mx-auto">
        <Button
          id="unsuccessful-alternative"
          name="unsuccessful-alternative"
          as="a"
          href="https://fiona.com/partner/symple-lending-loans/loans"
          variant="primary"
          size="lg"
          fullWidth
          icon={<ExternalLink className="w-5 h-5" />}
        >
          {t('unsuccessful.cta')}
        </Button>
      </div>
    </div>
  );
}